import axios from 'axios';
import { getApiBaseUrl } from '../utils/apiConfig';

const API_BASE_URL = getApiBaseUrl();

export const financialDashboardService = {
  // Reconciled Financial Reports
  getReconciledBalanceSheet: async (params = {}) => {
    const response = await axios.get(`${API_BASE_URL}/reports/enhanced/balance-sheet/reconciled`, {
      params,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });
    return response.data;
  },

  getReconciledIncomeStatement: async (params = {}) => {
    const response = await axios.get(`${API_BASE_URL}/reports/enhanced/income-statement/reconciled`, {
      params,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });
    return response.data;
  },

  getReconciledCashFlow: async (params = {}) => {
    const response = await axios.get(`${API_BASE_URL}/reports/enhanced/cash-flow/reconciled`, {
      params,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });
    return response.data;
  },

  getReconciledFinancialRatios: async (params = {}) => {
    const response = await axios.get(`${API_BASE_URL}/reports/enhanced/financial-ratios/reconciled`, {
      params,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });
    return response.data;
  },

  // Reconciliation Services
  getReconciliationSummary: async (params = {}) => {
    const response = await axios.get(`${API_BASE_URL}/reconciliation/summary`, {
      params,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });
    return response.data;
  },

  getDocumentReconciliation: async (documentType, params = {}) => {
    const response = await axios.get(`${API_BASE_URL}/reconciliation/documents/${documentType}`, {
      params,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });
    return response.data;
  },

  autoFixReconciliation: async (fixes) => {
    const token = localStorage.getItem('token')

    try {
      const response = await axios.post(`${API_BASE_URL}/reconciliation/auto-fix`,
        { fixes },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Auto-fix failed:', error.response?.status, error.response?.data)
      throw error;
    }
  },

  // Journal Entry Services
  bulkPostTransactions: async () => {
    const response = await axios.post(`${API_BASE_URL}/journal-entries/bulk-post`, {}, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });
    return response.data;
  },

  // Combined Financial Summary
  getFinancialSummary: async (params = {}) => {
    const [balanceSheet, incomeStatement, cashFlow, ratios, reconciliation] = await Promise.all([
      financialDashboardService.getReconciledBalanceSheet(params),
      financialDashboardService.getReconciledIncomeStatement(params),
      financialDashboardService.getReconciledCashFlow(params),
      financialDashboardService.getReconciledFinancialRatios(params),
      financialDashboardService.getReconciliationSummary(params)
    ]);

    return {
      balance_sheet: balanceSheet.data,
      income_statement: incomeStatement.data,
      cash_flow: cashFlow.data,
      financial_ratios: ratios.data,
      reconciliation_status: reconciliation.data
    };
  },

  // Trial Balance Report
  getTrialBalance: async (params = {}) => {
    const response = await axios.get(`${API_BASE_URL}/reports/enhanced/trial-balance`, {
      params,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });
    return response.data;
  },

  // Tax Transactions Report
  getTaxTransactions: async (params = {}) => {
    const response = await axios.get(`${API_BASE_URL}/reports/enhanced/tax-transactions`, {
      params,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });
    return response.data;
  },

  // Complete Financial Dashboard Data
  getFinancialDashboardData: async (params = {}) => {
    const response = await axios.get(`${API_BASE_URL}/reports/financial-data`, {
      params,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });
    return response.data;
  }
};